import ReactDOM from 'react-dom';
import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

import * as Actions from 'actions';

class NewRolesModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
    	name : '',
    	group : '',
    	is_admin_role : false
    }

		this.handleNameChange = this.handleNameChange.bind(this);
		this.handleGroupChange = this.handleGroupChange.bind(this);
		this.handleSubmitNewRole = this.handleSubmitNewRole.bind(this);
		this.handleCancelNewRole = this.handleCancelNewRole.bind(this);
  }

  handleNameChange(event) {
  	this.setState({name: event.target.value})
  }

  handleGroupChange(event) {
  	this.setState({group: event.target.value})
  }

  handleSubmitNewRole() {
  	if (this.state.body === '' || this.state.group === '') {
  		this.props.notify({message : "Please enter Name and Group for new role."});
  	}
  	else {
	  	this.props.beginAddRoles({
	  		name : this.state.name, 
	  		group : this.state.group,
	  		is_admin : this.state.is_admin_role
	  	})
	  	this.setState({name : '', group : '', is_admin_role : false})
	  	this.props.hide();
	  }
  }

  handleCancelNewRole() {
  	this.setState({name : '', group : ''})
  	this.props.hide();
  }

  render() {
    return (
    	<div className='new-role-modal-container panel panel-primary'>
				<div className='panel-heading'>
					<h4 className='panel-title'>Add New Role</h4>
				</div>
				<div className='panel-body'>
					{(() => {
						if(this.props.users.user.is_admin) {
							return (
								<div className='row'>
									<div className='new-role-admin-toggle-container col-xs-12 col-md-12'>
										<h5 className='pull-left'>Admin Role?</h5>
										<span className='pull-left ml-md switch switch-sm switch-success'>
											<div
												className={`ios-switch ${this.state.is_admin_role ? 'on' : 'off'}`}
												onClick={() => {this.setState({is_admin_role : !this.state.is_admin_role})}}
												>
												<div className='on-background background-fill' />
												<div className='state-background background-fill' />
												<div className='handle' />
											</div>
										</span>
									</div>
								</div>
								)
						}
					})()}
		  		<div className='form-group'>
		  			<section 
		  				id='new-role-modal-form'
		  				className='form-group-vertical'>
		  				<input 
		  					autoFocus
		  					className='form-control'
		  					type='text'
		  					placeholder='New Role Name'
		  					value={this.state.name}
		  					onChange={(e) => {this.setState({name: e.target.value})}}
		  				/>
		  				<input 
		  					className='form-control'
		  					type='text'
		  					placeholder='New Role Group'
		  					value={this.state.group}
		  					onChange={(e) => {this.setState({group: e.target.value})}}
		  				/>
		  			</section>
		  		</div>
					<div className='add-new-role-buttons-container'>
		  			<div 
		  				className='col-md-4 col-md-offset-2 col-xs-4 col-xs-offset-2 mr-xs roles-modal-button btn btn-danger'
		  				onClick={this.handleCancelNewRole}>
		  				Cancel
		  			</div>
		  			<div
		  				className='col-md-4 col-xs-4 roles-modal-button btn btn-primary'
		  				onClick={this.handleSubmitNewRole}>
		  				Submit
		  			</div>
		  		</div>
	  		</div>
  		</div>
    );
  }
}

let mapStateToProps = ({roleManagement, users}) => ({roleManagement, users})

export default connect(mapStateToProps, Actions)(NewRolesModal)



// WEBPACK FOOTER //
// ./src/browser/components/roleManagement/newRoleModal.js